import React, { useEffect, useCallback, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useStore } from '../../context/Context';
import SmartLink from '../fragments/SmartLink';

const Header = () => {
    const { global, siteLoaded, toggleMenu, getGlobal } = useStore();
    const headerInnerRef = useRef(null);

    const handleMenuToggle = (evt) => {
        evt.preventDefault();
        toggleMenu();
    };

    const handleColorModeToggle = useCallback((evt) => {
        evt.preventDefault();
        
        // Toggle the state-reverse class on the html element
        const htmlElement = document.documentElement;
        htmlElement.classList.toggle('state-reverse');
    }, []);

    const updateHeaderHeight = useCallback(() => {
        if (headerInnerRef.current) {
            const height = headerInnerRef.current.clientHeight;
            console.log('header height', height);
            document.documentElement.style.setProperty('--header-height', `${height}px`);
        }
    }, []);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            updateHeaderHeight();
        }, 0);

        window.addEventListener('resize', updateHeaderHeight);

        return () => {
            clearTimeout(timeoutId);
            window.removeEventListener('resize', updateHeaderHeight);
        };
    }, [updateHeaderHeight]);

    useEffect(() => {
        if (global.json) {
            const timeoutId = setTimeout(() => {
                updateHeaderHeight();
            }, 100);

            return () => clearTimeout(timeoutId);
        }
    }, [global.json, updateHeaderHeight]);

    useEffect(() => {
        if (global.json === null && !global.globalFetched) {
            const globalUrl = `${window.location.origin}/wp-json/adelebates/v1/global`;
            getGlobal(globalUrl);
        }
    }, [global.json, global.globalFetched, getGlobal]);

    if (!global.json && global.globalFetched) {
        return null;
    }

    if (!global.json) {
        return null;
    }

    console.log('global', global);

    return (
        <>
            <div className="c-header">
                <header className="c-header__inner" ref={headerInnerRef}>
                    <h1 className="c-header__logo">
                        <SmartLink
                            to="/" 
                            className="c-header__logo__inner" 
                            dangerouslySetInnerHTML={{
                                __html: '<svg viewBox="0 0 104 12"><path d="M3.94.62L.09,11.42h2.36l.75-2.22h3.98l.7,2.22h2.45L6.49.62h-2.55ZM3.8,7.34l1.39-4.25,1.35,4.25h-2.74ZM19.84,2.23c-.47-.66-1.08-1.12-1.84-1.37-.44-.15-1-.22-1.67-.23h-4.65v10.8h4.65c1.63,0,2.84-.67,3.62-2.01.58-1,.86-2.21.86-3.65,0-.57-.07-1.16-.21-1.79-.14-.62-.39-1.21-.77-1.74ZM18.18,7.97c-.42,1.05-1.16,1.57-2.23,1.57h-2.08V2.5h2.08c1.03,0,1.71.29,2.06.88.34.59.51,1.44.51,2.53,0,.8-.12,1.48-.34,2.06ZM24.78,6.7h5.24v-1.88h-5.24v-2.29h5.71V.62h-7.92v10.8h8.18v-1.94h-5.98v-2.78ZM34.77.62h-2.26v10.8h7.6v-1.94h-5.35V.62ZM43.95,6.7h5.24v-1.88h-5.24v-2.29h5.71V.62h-7.92v10.8h8.18v-1.94h-5.98v-2.78ZM63.13,5.62c.36-.19.63-.39.82-.62.33-.4.5-.93.5-1.59s-.17-1.19-.5-1.65c-.55-.75-1.49-1.13-2.81-1.15h-5.24v10.8h4.89c.55,0,1.06-.05,1.53-.15.47-.1.88-.28,1.23-.54.31-.23.56-.51.77-.85.32-.51.48-1.08.48-1.72s-.14-1.15-.42-1.58c-.28-.43-.7-.75-1.25-.95ZM58.04,2.5h2.37c.52,0,.95.06,1.29.17.39.16.59.49.59,1,0,.45-.15.77-.44.94-.3.18-.68.27-1.16.27h-2.65v-2.38ZM61.8,9.35c-.26.13-.63.19-1.11.19h-2.65v-2.88h2.69c.47,0,.83.07,1.09.18.46.21.7.6.7,1.16,0,.66-.24,1.11-.72,1.35ZM69.78.62l-3.85,10.8h2.36l.75-2.22h3.98l.7,2.22h2.45l-3.82-10.8h-2.55ZM69.64,7.34l1.39-4.25,1.35,4.25h-2.74ZM75.51,2.53h3.25v8.88h2.27V2.53h3.23V.62h-8.75v1.91ZM87.84,6.7h5.24v-1.88h-5.24v-2.29h5.71V.62h-7.92v10.8h8.18v-1.94h-5.98v-2.78ZM102.95,6.06c-.42-.33-1.03-.59-1.85-.78l-1.86-.45c-.72-.17-1.19-.32-1.41-.45-.34-.19-.51-.48-.51-.86,0-.42.17-.75.52-.98s.81-.35,1.39-.35c.52,0,.96.09,1.31.27.53.27.81.74.85,1.38h2.17c-.04-1.15-.46-2.02-1.26-2.63-.8-.6-1.77-.91-2.91-.91-1.36,0-2.39.32-3.1.96s-1.05,1.44-1.05,2.41c0,1.06.36,1.84,1.09,2.34.43.3,1.21.57,2.33.83l1.14.26c.67.15,1.16.32,1.47.5.31.2.47.47.47.83,0,.61-.32,1.03-.95,1.25-.33.12-.76.18-1.3.18-.89,0-1.52-.22-1.88-.67-.2-.24-.33-.61-.4-1.11h-2.15c0,1.12.4,2,1.21,2.65.81.64,1.91.96,3.32.96s2.44-.33,3.2-.98c.75-.65,1.13-1.47,1.13-2.46s-.32-1.7-.97-2.21Z" style="fill: #292e1d;"/></svg>'
                            }}
                        />
                    </h1>
                    <button 
                        type="button"
                        className="c-header__menu-button" 
                        onClick={handleMenuToggle}
                        aria-label="Toggle menu"
                    >
                        <span className="c-header__menu-button__text">Menu</span>
                        <span className="c-header__menu-button__text">Close</span>
                    </button>
                    <SmartLink
                        to="/studio" 
                        className="c-header__link c-underline-on-hover" 
                        dangerouslySetInnerHTML={{ __html: 'Studio'}}
                    />
                    <SmartLink
                        to="/projects" 
                        className="c-header__link c-underline-on-hover" 
                        dangerouslySetInnerHTML={{ __html: 'Projects'}}
                    />
                </header>
            </div>

            <div className="c-header__rule" />

            <div className="c-header__menu">
                <div className="c-header__menu__top"></div>
                <nav className="c-header__menu__nav" aria-label="Primary">
                    <ul className="c-header__menu__list">
                        <li className="c-header__menu__item">
                            <SmartLink
                                to={'/studio'}
                                className="c-header__menu__link"
                                dangerouslySetInnerHTML={{ __html: 'Studio'}}
                            />
                        </li>
                        <li className="c-header__menu__item">
                            <SmartLink
                                to={'/projects'}
                                className="c-header__menu__link"
                                dangerouslySetInnerHTML={{ __html: 'Projects'}}
                            />
                        </li>
                        <li className="c-header__menu__item">
                            <SmartLink
                                to={'/contact'}
                                className="c-header__menu__link"
                                dangerouslySetInnerHTML={{ __html: 'Contact'}}
                            />
                        </li>
                    </ul>
                    <div className="c-header__menu__social">
                        {global.json.social_links && (
                            <div className="c-header__menu__social__inner scope-text" dangerouslySetInnerHTML={{__html: global.json.social_links }} />
                        )}
                    </div>
                </nav>

                <div className="c-header__menu__footer">
                    {global.json.ftr_min_contact_info && (
                        <div className="c-header__menu__contact-info scope-text" dangerouslySetInnerHTML={{ __html: global.json.ftr_min_contact_info }} />
                    )}
                </div>
            </div>
            
            <button 
                className="c-header__color-mode-button" 
                onClick={handleColorModeToggle}
                aria-label="Toggle color mode"
            />
            
        </>
    );
};

export default Header;
